import { apiService } from './api';
import { ApplicationsResponse } from '@/types/applications';

export const fetchApplications = (userEmail: string): Promise<ApplicationsResponse> =>
  apiService.get<ApplicationsResponse>('/v1/applications', {
    params: { user_email: userEmail },
  });
